import React, { useState } from "react";
import styles from "../../styles/components/exportBotBand.module.scss";
import Icons from "../../public/assets/svg";
import { useRouter } from "next/router";
import endpoint from "../../utility/endpoints";
import axios from "axios";
import { filter } from "jszip";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CRDemo from "./CRDemo";
import AssociateBots from "./AssociateBots";

function index(props) {
  const [admin, setadmin] = useState(true);
  const router = useRouter();
  const createBot = () => {
    router.push("/createBotNew");
  };

  const [createAccess, setCreateAccess] = useState([
    "admin",
    "qrManager",
    "internalUser",
    "supportStatus",
  ]);
  const getAllBotsInExcel = async () => {
    let exportFilter = props.filters;
    if (exportFilter.search != undefined) {
      delete exportFilter.search;
    }

    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      props.setLoading(true);

      axios({
        method: "get",
        url: `${endpoint.baseUrl}/bot/getBotsInExcel`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        params: exportFilter,
      }).then((resp) => {
        props.setLoading(false);
        if (resp.data.code == 200) {
          //console.log(resp.data, "demandexcelresponse");
          window.open(resp.data.data);
        } else if (resp.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          props.sessionTimeOutCheck(true);
        }
      });
    } else {
      props.sessionTimeOutCheck(true);
      props.setLoading(false)
    }
  };


   const exportCustomBots = async () => {
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      props.setLoading(true);

      axios({
        method: "get",
        url: `${endpoint.baseUrl}/bot/custom-export`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      })
        .then((resp) => {
          props.setLoading(false);
          if (
            resp.data.status === "success" &&
            resp.data.message === "Bot data fetched"
          ) {
            window.open(resp.data.data.URL);
          } else if (resp.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
          }
        })
        .catch((e) => {
          console.log(e);
          props.setLoading(false);
        });
    } else {
      props.sessionTimeOutCheck(true);
      props.setLoading(false);
    }
  };


  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className={styles.bandWrapper}>
            {/* {createAccess.includes(props.userRole) ? (
              <p className={styles.txt}>
                Choose from the options to export or create a bot.
              </p>
            ) : (
              <p className={styles.txt}>Export the bot details listed below.</p>
            )} */}
            <div className={styles.configBtn}>
              <span className={styles.btn} onClick={getAllBotsInExcel}>
                <Icons name="uploadicon" className={styles.exportIcon}></Icons>
                Export Bot list
              </span>
              {createAccess.includes(props.userRole) ? (
                <span className={styles.createbtn} onClick={createBot}>
                  Create a New Bot
                </span>
              ) : null}

              {props.userRole !== "endUser" &&
              props.userRole !== "businessOwner" ? (
                <span
                  onClick={exportCustomBots}
                  className="mx-3 px-3 cursor-pointer bg-[#00d7c5] text-[#1f36c7] font-unilever-shilling-medium hidden md:flex justify-center items-center"
                >
                  Export Custom Bots
                </span>
              ) : null}
             <CRDemo />  
             {props.userRole === "admin" && <AssociateBots />}         
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
